import { GetPublicOffersState } from './getPublicOffers.types'

const initialState: GetPublicOffersState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
